export const shortenString = (str: string, length: number, withEllipses = true) => {
  if (str.length > length) {
    return str.substring(0, length).concat(withEllipses ? '...' : '');
  }

  return str;
};
